import axios from 'axios'
import { Message } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { CustomAxiosConfig } from '@/types/axios'

// import Cookies from 'js-cookie'

const service = axios.create({
  baseURL: '/bi',
  timeout: 150000
})

// Request interceptors
service.interceptors.request.use(
  (config: CustomAxiosConfig) => {
    if (!(typeof config.loading === 'boolean' && config.loading === false)) {
      AppModule.COMMIT_LOADING(true)
    }
    // Add X-Access-Token header to every request, you can add other custom headers here
    // if (UserModule.token) {
    //   // config.headers['X-Access-Token'] = UserModule.token
    // }
    const user = localStorage.getItem('user')
    const token = '1'
    // let token = ''
    // if (user) {
    //   token = JSON.parse(user).token
    // }

    // const token = window.localStorage.getItem('token') || Cookies.get('nbToken')

    // config.headers['Authorization'] = 'bearer ' + token
    config.headers['token'] = token
    return config
  },
  (error) => {
    AppModule.COMMIT_LOADING(false)
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // 本地环境需要注释、生产环境需要放开
    AppModule.COMMIT_LOADING(false)
    if (response.data.code !== 0) {
      Message({
        message: response.data.error,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return response.data
  },
  (error) => {
    AppModule.COMMIT_LOADING(false)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
